import axios from 'axios';
import { Storage } from '../Storage/Storage'

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL

const client = axios.create({
    baseURL: REACT_APP_API_BASEURL,
    withCredentials: false
});

let cancelTokenSource = axios.CancelToken.source();

const header = () => {
    let headers = {
        "Content-Type": "application/json",
        'Accept': 'application/json',
    }

    if (Storage.get('auth') && Storage.get('auth').authToken) {
        headers['Authorization'] = Storage.get('auth').authToken
    }
    return headers
}


class DataService {

    // GET --
    static get(path = "", params = false, cancel=false,optionalHeader) {
        if(cancel){
            cancelTokenSource.cancel('Request canceled by new API call');
        }
        cancelTokenSource = axios.CancelToken.source();

        if (params) {
            params = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        }
        return client({
            method: "GET",
            url: params ? path + '?' + params : path,
            headers: header(optionalHeader),
            cancelToken: cancelTokenSource.token,
        });
    }

    // POST--'''

    static post(path = "", data = {}, optionalHeader) {
        return client({
            method: "POST",
            url: path,
            data,
            headers: header(optionalHeader)
        });
    }

    // DELETE--'''

    static delete(path = "", data = {}, optionalHeader) {
        return client({
            method: "DELETE",
            url: path,
            data,
            headers: header(optionalHeader)
        });
    }

    static convertObjToQueryStr = (params) => {
        const objStr = "?" + Object.keys(params).map(key => {
          return `${key}=${encodeURIComponent(params[key])}`
        }).join('&')
        return objStr
      }
      
    // PUT--'''

    static put(path = "", data = {}, optionalHeader) {
        return client({
            method: "PUT",
            url: path,
            data,
            headers: header(optionalHeader)
        });
    }

}

client.interceptors.request.use(config => {
    const requestConfig = config;
    const { headers } = config;
    requestConfig.headers = { ...headers };

    return requestConfig;
});

client.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        const { response, config } = error;
        if (response && config.url !== "/admin/login") {
            // if (response.data.response_status === 401) {
            //     Storage.remove('auth')
            // }
            return response.data;
        } else {
            if (response && response.data) {
                return response.data
            } else {
                return false
            }
        }
        // return Promise.reject(error);
    }
);
export { DataService };
